import { useContactManagementTranslation } from '../../ui/hooks';
import React from 'react';
export const ContactManagementConfigContext = React.createContext(undefined);
export const ContactManagementConfigProvider = ({ appName, appContext, notificationConfig, accountConfig, accountsTableCustomization, userDirectoryTableCustomization, children, }) => {
    const { ready } = useContactManagementTranslation();
    React.useEffect(() => {
        const handleTimeout = setTimeout(() => {
            if (!ready) {
                console.warn('Translations were not loaded...');
            }
        }, 10 * 1000);
        return () => clearTimeout(handleTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const contactManagementConfig = React.useMemo(() => {
        return {
            appName: appName,
            appContext: appContext,
            notificationConfig: notificationConfig,
            accountConfig: accountConfig,
            accountsTableCustomization,
            userDirectoryTableCustomization,
        };
    }, [appContext, appName, accountConfig, notificationConfig, accountsTableCustomization, userDirectoryTableCustomization]);
    return (React.createElement(ContactManagementConfigContext.Provider, { value: contactManagementConfig }, ready && children));
};
